export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_01.791fc148.jpg";